import { render, staticRenderFns } from "./hqglTelDetailFee.vue?vue&type=template&id=95b223be&scoped=true&"
import script from "./hqglTelDetailFee.vue?vue&type=script&lang=js&"
export * from "./hqglTelDetailFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b223be",
  null
  
)

export default component.exports